(function () {
  var DASHBOARD = "https://tracktech-ops-dashboard.vercel.app";
  var FINDER_FALLBACK = "";

  function norm(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "")
      .trim();
  }

  function apiGet(url) {
    return fetch(url, {
      method: "GET",
      credentials: "omit",
      headers: { Accept: "application/json, text/plain, */*" },
    }).then(function (r) {
      return r.text().then(function (t) {
        var j = null;
        try {
          j = t ? JSON.parse(t) : null;
        } catch (e) {
          var start = t.indexOf("{");
          var end = t.lastIndexOf("}");
          if (start >= 0 && end > start) j = JSON.parse(t.slice(start, end + 1));
        }
        if (!r.ok) throw new Error((j && j.error) || "HTTP " + r.status);
        if (j && typeof j.error === "string") throw new Error(j.error);
        return j || {};
      });
    });
  }

  function flattenFinder(data) {
    var makes = {};
    Object.keys(data || {}).forEach(function (type) {
      var byMake = data[type] || {};
      Object.keys(byMake).forEach(function (make) {
        var rows = byMake[make] || [];
        if (!makes[make]) makes[make] = [];
        rows.forEach(function (row) {
          if (!row || !row.handle) return;
          var exists = makes[make].some(function (m) {
            return m.handle === row.handle;
          });
          if (!exists) {
            makes[make].push({
              handle: row.handle,
              model: row.model || row.handle,
              make: make,
              type: type,
            });
          }
        });
      });
    });
    return makes;
  }

  function indexListed(rows) {
    var map = {};
    (rows || []).forEach(function (row) {
      if (!row || !row.handle || !row.make) return;
      if (!map[row.make]) map[row.make] = [];
      if (!map[row.make].some(function (m) { return m.handle === row.handle; })) {
        map[row.make].push({
          handle: row.handle,
          model: row.model || row.handle,
          make: row.make,
        });
      }
    });
    return map;
  }

  function readListed(root) {
    var node = root && root.querySelector("[data-tt-listed-json]");
    if (!node) return null;
    try {
      var parsed = JSON.parse(node.textContent || "null");
      if (!parsed || !Array.isArray(parsed.machines)) return null;
      return parsed.machines;
    } catch (e) {
      return [];
    }
  }

  function FinderIndex(url) {
    this.url = url;
    this.promise = null;
    this.map = null;
  }

  FinderIndex.prototype.load = function () {
    var self = this;
    if (self.map) return Promise.resolve(self.map);
    if (self.promise) return self.promise;
    if (!self.url) return Promise.reject(new Error("finder_missing"));
    self.promise = apiGet(self.url)
      .then(function (data) {
        self.map = flattenFinder(data);
        return self.map;
      })
      .catch(function (err) {
        self.promise = null;
        throw err;
      });
    return self.promise;
  };

  function Client(opts) {
    this.apiBase = String((opts && opts.apiBase) || DASHBOARD).replace(/\/$/, "");
    this.finder = new FinderIndex((opts && opts.finderUrl) || FINDER_FALLBACK);
    if (opts && Object.prototype.hasOwnProperty.call(opts, "listed")) {
      this.listed = opts.listed === null ? null : indexListed(opts.listed);
    } else {
      this.listed = null;
    }
  }

  Client.prototype.setListed = function (rows) {
    this.listed = rows === null ? null : indexListed(rows);
  };

  Client.prototype.dashboardMakes = function () {
    return apiGet(this.apiBase + "/api/storefront/intelligent-fitment?view=makes").then(function (data) {
      var list = data.makes || data;
      if (!Array.isArray(list) || !list.length) throw new Error("makes_empty");
      return list.map(function (row) {
        return typeof row === "string" ? row : row.make || row.label || row.name;
      }).filter(Boolean);
    });
  };

  Client.prototype.dashboardModels = function (make) {
    return apiGet(
      this.apiBase + "/api/storefront/intelligent-fitment?view=models&make=" + encodeURIComponent(make)
    ).then(function (data) {
      var list = data.models || data;
      if (!Array.isArray(list) || !list.length) throw new Error("models_empty");
      return list
        .map(function (row) {
          return {
            handle: row.handle || row.equipment_handle || "",
            model: row.model || row.name || row.label || "",
            make: make,
          };
        })
        .filter(function (row) {
          return row.handle;
        });
    });
  };

  Client.prototype.dashboardMachine = function (handle, configuration) {
    var path =
      this.apiBase +
      "/api/storefront/intelligent-fitment?view=machine&handle=" +
      encodeURIComponent(handle);
    if (configuration) path += "&configuration=" + encodeURIComponent(configuration);
    return apiGet(path).then(function (data) {
      if (!data || data.status === "BLOCKED") throw new Error("machine_blocked");
      if (!data.equipment && !data.tracks && !data.undercarriage && !data.fits) {
        throw new Error("machine_empty");
      }
      return data;
    });
  };

  Client.prototype.themeMakes = function () {
    return this.finder.load().then(function (map) {
      return Object.keys(map).sort();
    });
  };

  Client.prototype.themeModels = function (make) {
    var want = norm(make);
    return this.finder.load().then(function (map) {
      var key = Object.keys(map).find(function (mk) {
        return norm(mk) === want;
      });
      return key ? map[key] : [];
    });
  };

  Client.prototype.themeMachine = function (handle, configuration) {
    var url = "/collections/" + encodeURIComponent(handle) + "?view=tt-equipment-machine";
    return apiGet(url).then(function (data) {
      if (!data || !data.equipment || !data.equipment.handle) throw new Error("machine_missing");
      if (data.status === "BLOCKED") throw new Error("machine_blocked");
      var needs = handle === "bobcat-t870" || handle === "bobcat-t590";
      if (needs && !configuration) {
        data.size = data.size || { mode: "differentiator" };
      }
      return data;
    });
  };

  Client.prototype.loadMakes = function () {
    var self = this;
    if (self.listed) return Promise.resolve(Object.keys(self.listed).sort());
    return self.dashboardMakes().catch(function () {
      return self.themeMakes();
    });
  };

  Client.prototype.loadModels = function (make) {
    var self = this;
    if (!make) return Promise.resolve([]);
    if (self.listed) {
      var want = norm(make);
      var key = Object.keys(self.listed).find(function (mk) {
        return norm(mk) === want;
      });
      return Promise.resolve(key ? self.listed[key] : []);
    }
    return self.dashboardModels(make).catch(function () {
      return self.themeModels(make);
    });
  };

  Client.prototype.loadMachine = function (handle, configuration) {
    var self = this;
    if (!handle) return Promise.reject(new Error("handle_required"));
    return self.dashboardMachine(handle, configuration).catch(function () {
      return self.themeMachine(handle, configuration);
    });
  };

  function readFleet() {
    try {
      var raw = window.localStorage.getItem("ttFleetMachines");
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function saveFleet(item) {
    if (!item || !item.handle) return;
    var next = [item].concat(
      readFleet().filter(function (row) {
        return row.handle !== item.handle;
      })
    );
    window.localStorage.setItem("ttFleetMachines", JSON.stringify(next));
    document.dispatchEvent(new CustomEvent("tt-fleet:start"));
  }

  function fillSelect(el, rows, getValue, getLabel, placeholder) {
    if (!el) return;
    var current = el.value;
    el.innerHTML = "";
    var first = document.createElement("option");
    first.value = "";
    first.textContent = placeholder || "Select";
    el.appendChild(first);
    (rows || []).forEach(function (row) {
      var opt = document.createElement("option");
      opt.value = getValue(row);
      opt.textContent = getLabel(row);
      if (row.handle) opt.dataset.handle = row.handle;
      if (row.model) opt.dataset.model = row.model;
      el.appendChild(opt);
    });
    if (current) {
      Array.prototype.some.call(el.options, function (opt) {
        if (opt.value === current) {
          el.value = current;
          return true;
        }
        return false;
      });
    }
    el.disabled = !(rows || []).length;
  }

  function configFor(handle, machine) {
    if (machine && machine.size && machine.size.mode === "differentiator" && machine.size.differentiator) {
      return machine.size.differentiator;
    }
    if (handle === "bobcat-t870") {
      return {
        question: "T870 torsion vs suspension is required.",
        options: [
          { value: "torsion", label: "Torsion mount" },
          { value: "suspension", label: "Suspension mount" },
        ],
      };
    }
    if (handle === "bobcat-t590") {
      return {
        question: "T590 narrow vs wide is required.",
        options: [
          { value: "narrow", label: "Narrow" },
          { value: "wide", label: "Wide" },
        ],
      };
    }
    return null;
  }

  function mount(root, options) {
    if (!root || root.dataset.ttSelReady === "1") return null;
    var opts = options || {};
    var listedRows = Object.prototype.hasOwnProperty.call(opts, "listed") ? opts.listed : readListed(root);
    var client = new Client({
      apiBase: root.getAttribute("data-api-base") || opts.apiBase,
      finderUrl: root.getAttribute("data-finder-url") || opts.finderUrl,
      listed: listedRows,
    });
    var makeEl = root.querySelector("[data-tt-sel-make]");
    var modelEl = root.querySelector("[data-tt-sel-model]");
    var configEl = root.querySelector("[data-tt-sel-config]");
    var configWrap = root.querySelector("[data-tt-sel-config-wrap]");
    var handleEl = root.querySelector("[data-tt-sel-handle]");
    var state = { make: "", handle: "", machine: null, configuration: "" };
    root.dataset.ttSelReady = "1";

    function emit(name, detail) {
      root.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
    }

    function setConfig(diff) {
      if (!configEl || !configWrap) return;
      if (!diff) {
        configWrap.hidden = true;
        configEl.required = false;
        configEl.innerHTML = '<option value="">Select configuration</option>';
        return;
      }
      configWrap.hidden = false;
      configEl.required = true;
      fillSelect(
        configEl,
        diff.options || [],
        function (row) {
          return row.value;
        },
        function (row) {
          return row.label || row.value;
        },
        diff.question || "Select configuration"
      );
    }

    function applyMachine(data, handle) {
      state.machine = data;
      state.handle = handle;
      if (handleEl) handleEl.value = (data.equipment && data.equipment.handle) || handle;
      var diff = configFor(handle, data);
      setConfig(diff);
      emit("tt-machine:selected", {
        handle: handle,
        make: state.make,
        model: (modelEl && modelEl.selectedOptions[0] && modelEl.selectedOptions[0].dataset.model) || "",
        machine: data,
        configuration: state.configuration,
        needsConfig: !!diff && !state.configuration,
      });
    }

    function loadSelectedMachine() {
      var handle = modelEl ? modelEl.value : "";
      state.configuration = configEl && !configWrap.hidden ? configEl.value : "";
      if (!handle) {
        if (handleEl) handleEl.value = "";
        setConfig(null);
        emit("tt-machine:cleared", {});
        return Promise.resolve(null);
      }
      return client.loadMachine(handle, state.configuration).then(function (data) {
        applyMachine(data, handle);
        return data;
      });
    }

    makeEl.addEventListener("change", function () {
      state.make = makeEl.value;
      state.handle = "";
      if (handleEl) handleEl.value = "";
      fillSelect(modelEl, [], function () { return ""; }, function () { return ""; }, "Select model");
      setConfig(null);
      if (!state.make) return;
      client.loadModels(state.make).then(function (models) {
        fillSelect(
          modelEl,
          models,
          function (row) {
            return row.handle;
          },
          function (row) {
            return row.model;
          },
          "Select model"
        );
      });
    });

    modelEl.addEventListener("change", function () {
      loadSelectedMachine();
    });

    if (configEl) {
      configEl.addEventListener("change", function () {
        loadSelectedMachine();
      });
    }

    function listedHas(handle) {
      if (!client.listed || !handle) return !client.listed;
      return Object.keys(client.listed).some(function (make) {
        return client.listed[make].some(function (row) {
          return row.handle === handle;
        });
      });
    }

    function populateMakes() {
    return client.loadMakes().then(function (makes) {
      fillSelect(
        makeEl,
        makes,
        function (row) {
          return typeof row === "string" ? row : row.make;
        },
        function (row) {
          return typeof row === "string" ? row : row.make;
        },
        makes && makes.length ? "Select make" : "No listed machines"
      );
      var pre = opts.prefill || {};
      if (!pre.make && !pre.handle) {
        var fleet = readFleet();
        if (fleet[0] && listedHas(fleet[0].handle)) {
          pre = { make: fleet[0].make, handle: fleet[0].handle, model: fleet[0].model };
        }
      }
      if (pre.make) {
        makeEl.value = pre.make;
        if (!makeEl.value) {
          Array.prototype.some.call(makeEl.options, function (opt) {
            if (norm(opt.value) === norm(pre.make)) {
              makeEl.value = opt.value;
              return true;
            }
            return false;
          });
        }
        if (makeEl.value) {
          return client.loadModels(makeEl.value).then(function (models) {
            fillSelect(
              modelEl,
              models,
              function (row) {
                return row.handle;
              },
              function (row) {
                return row.model;
              },
              "Select model"
            );
            if (pre.handle) modelEl.value = pre.handle;
            if (modelEl.value) return loadSelectedMachine();
            return null;
          });
        }
      }
      return null;
    });
    }

    populateMakes();

    var api = {
      client: client,
      state: state,
      applyListed: function (rows) {
        client.setListed(rows);
        state.make = "";
        state.handle = "";
        if (handleEl) handleEl.value = "";
        fillSelect(modelEl, [], function () { return ""; }, function () { return ""; }, "Select model");
        setConfig(null);
        return populateMakes();
      },
      prefillHandle: function (handle) {
        handle = String(handle || "").trim();
        if (!handle) return Promise.resolve(null);
        return client.loadMakes().then(function (makes) {
          var list = (makes || []).map(function (row) {
            return typeof row === "string" ? row : row.make;
          }).filter(Boolean);
          var index = 0;
          function next() {
            if (index >= list.length) return null;
            var make = list[index++];
            return client.loadModels(make).then(function (models) {
              var match = (models || []).filter(function (row) { return row.handle === handle; })[0];
              if (!match) return next();
              fillSelect(makeEl, makes, function (row) {
                return typeof row === "string" ? row : row.make;
              }, function (row) {
                return typeof row === "string" ? row : row.make;
              }, "Select make");
              makeEl.value = make;
              state.make = make;
              fillSelect(modelEl, models, function (row) { return row.handle; }, function (row) { return row.model; }, "Select model");
              modelEl.value = handle;
              return loadSelectedMachine();
            });
          }
          return next();
        });
      },
      saveFleet: function () {
        if (!state.handle) return;
        var modelLabel =
          (modelEl && modelEl.selectedOptions[0] && modelEl.selectedOptions[0].dataset.model) || "";
        saveFleet({
          handle: state.handle,
          name: [state.make, modelLabel].filter(Boolean).join(" "),
          make: state.make,
          model: modelLabel,
          type: "",
          savedAt: Date.now(),
        });
      },
    };
    root._ttSelector = api;
    return api;
  }

  window.TTMachineSelector = {
    Client: Client,
    mount: mount,
    readFleet: readFleet,
    saveFleet: saveFleet,
    flattenFinder: flattenFinder,
    applyListed: function (root, rows) {
      if (!root || !root._ttSelector) return null;
      return root._ttSelector.applyListed(rows);
    },
  };

  document.querySelectorAll("[data-tt-machine-selector]").forEach(function (root) {
    mount(root);
  });
})();
